import styles from './OnboardingLoader.module.scss';
import ballImg from '../../assets/icon/OnboardIcon.svg';
import SingInImg from '../../assets/image/signIn.png';

const OnboardingLoader = () => {
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <div className={styles.inner}>
            <div className={styles.blurBlock}>
              <img className={styles.ballImgBlur} src={ballImg} alt="" />
              <div className={styles.skeletonTitle} />
              <div className={styles.skeletonText} />
            </div>
            <div className={styles.loaderBlock}>
              <div className={styles.loader} />
              <span className={styles.label}>Завантаження</span>
            </div>
          </div>
        </div>
        <div className={styles.imageContainer}>
          <img src={SingInImg} alt="tennis" />
        </div>
      </div>
    </div>
  );
};

export default OnboardingLoader;
